import { createReducer, on } from "@ngrx/store";
import * as UserActions from './user.actions';
import { User } from "@app/core/model/user/user.model";

export const AUTH_USER_KEY = 'user';

export interface UserState {
    user: User | undefined;
}

const initialState: UserState = {
    user: undefined
};

export const USER_REDUCER = createReducer(
    initialState,
    on(UserActions.SET_USER_DATA, (state: UserState, action: User): UserState => {
        return {
          ...state,
          user: action
        };
      })
)



            